'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of stress
 */ const Stress = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 105",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52.4512",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("g", {
                clipPath: "url(#clip0_3427_20663)",
                children: /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M79.3672 46.7271C79.232 31.8014 67.0292 19.6361 52.1035 19.5435C36.8725 19.4509 24.497 31.7713 24.497 46.9798C24.497 47.8357 24.5396 48.6741 24.6196 49.5075C24.6647 49.993 24.5796 50.4835 24.3744 50.924L20.1825 61.2273C20.0073 61.6552 20.0348 62.1433 20.2826 62.5337C20.5278 62.9241 20.9533 63.1643 21.4188 63.1793L24.92 63.7374C25.5882 63.845 26.0787 64.3931 26.1613 65.0588L27.4201 75.262C27.6253 76.9313 29.0893 78.1551 30.7661 78.0625L35.0481 77.8297C37.4006 77.7021 39.3802 79.5766 39.3802 81.9341V85.2225C39.3802 85.3752 39.5028 85.4978 39.6554 85.4978H69.1565C69.3341 85.4978 69.4643 85.3301 69.4217 85.1574C67.2319 76.148 68.6009 70.5421 72.9955 64.5658C77.0222 59.7457 79.4298 53.5167 79.3672 46.7296V46.7271Z",
                    fill: theme.ds5.asset[assetColor]["500"]
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip1_3427_20663)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        x: "46.6719",
                        y: "32.0391",
                        width: "11.5088",
                        height: "20.6316",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M52.4973 28.6602C45.0944 28.6602 39.0938 34.6608 39.0938 42.0659C39.0938 49.4709 45.0944 55.4694 52.4973 55.4694C59.9001 55.4694 65.9008 49.4687 65.9008 42.0659C65.9008 34.663 59.9001 28.6602 52.4973 28.6602ZM57.5703 41.1777L51.9241 51.0788C51.806 51.2845 51.62 51.4201 51.41 51.4682C51.2569 51.5032 51.0906 51.4945 50.9287 51.431C50.5459 51.2823 50.3425 50.8994 50.4343 50.4991L51.8082 44.4832L48.133 44.4788C47.877 44.4788 47.6408 44.3607 47.4832 44.1572C47.3279 43.9538 47.2776 43.6934 47.3432 43.4462L49.964 33.8295C50.0624 33.4729 50.384 33.2257 50.7559 33.2257L54.978 33.2323C55.2493 33.2323 55.503 33.3679 55.6562 33.5954C55.8071 33.8207 55.8377 34.1051 55.7371 34.3567L53.4839 39.9526L56.8637 39.957C57.1591 39.957 57.4216 40.1101 57.5703 40.3639C57.7191 40.6198 57.7191 40.9239 57.5725 41.1799L57.5703 41.1777Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                        id: "clip0_3427_20663",
                        children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                            width: "59.2973",
                            height: "65.9518",
                            fill: "white",
                            transform: "translate(20.0703 19.543)"
                        })
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                        id: "clip1_3427_20663",
                        children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                            width: "26.807",
                            height: "26.807",
                            fill: "white",
                            transform: "translate(39.0938 28.6602)"
                        })
                    })
                ]
            })
        ]
    });
};

exports.Stress = Stress;
//# sourceMappingURL=Stress.cjs.map
